module.exports = __webpack_public_path__ + "static/cad-8ad615bb411424b356ef96efe1afd115.jpg";